/**
 * Deep Research feature configuration
 * Centralizes model names for frontend display
 */

// Model configuration constants
export const DEEP_RESEARCH_MODEL_NAME = 'o4 Mini Deep Research';